import * as React from "react";
import { ArrowRight, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheSterlingStandard() {
  return <section data-section-id="233571" id="the-sterling-standard" className="bg-background text-foreground relative w-full min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 py-20 lg:px-16 xl:px-24 z-10 relative">
        {}
        <div className="absolute top-0 left-0 w-full h-full bg-primary/5 blur-[100px] -z-10 rounded-md pointer-events-none" />

        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-primary/10 border border-primary/20 text-primary-foreground mb-8">
            <Globe className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium tracking-widest text-primary font-mono uppercase">Established Excellence</span>
          </div>

          <h1 className="font-default text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[1.1] mb-6 text-foreground">
            The Sterling Standard.
          </h1>

          <p className="text-muted-foreground text-lg sm:text-xl leading-relaxed mb-10 max-w-xl font-default">
            Unwavering legal authority for the modern era. We provide sophisticated counsel in <strong className="text-foreground font-semibold">Real Estate, Family Law, and Corporate Litigation</strong> with unshakeable precision.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="h-14 px-8 text-base rounded-md shadow-lg shadow-primary/30 bg-primary hover:bg-primary/90 transition-all duration-500 animate-pulse">
              <Link to="/ContactPage">
                Free Consultation
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base rounded-md border-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground transition-colors duration-500">
              <Link to="/TheFirmPage">
                Our Practice Areas
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-1/2 relative min-h-[50vh] lg:min-h-screen">
        {}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[20000ms] ease-linear hover:scale-110" style={{
        backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/sterling_law_office_dusk.png)'
      }} aria-label="Modern glass law office building at dusk" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:hidden" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/40 to-transparent hidden lg:block" />
        <div className="absolute inset-0 bg-black/40" /> {}
      </div>
    </section>;
}